import { render, staticRenderFns } from "./PageSheet.vue?vue&type=template&id=6b68f44b&scoped=true&"
import script from "./PageSheet.vue?vue&type=script&lang=js&"
export * from "./PageSheet.vue?vue&type=script&lang=js&"
import style0 from "./PageSheet.vue?vue&type=style&index=0&id=6b68f44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68f44b",
  null
  
)

export default component.exports